module.exports = __webpack_public_path__ + "img/no.v4.2.2.1769759786845.png";